module.exports = __webpack_public_path__ + "static/massingInit-78141492ab5fdca3cc35ec3d4a841744.png";